import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { Tooltip } from '../../ui/Tooltip/Tooltip';
import { SparkleGradient } from '../../ui/Spinner/SparkleGradient';
import { SPARKLE_PATH, SPARKLE_VIEW_BOX } from '../../ui/Spinner/sparklePath';
import type { AiSparkleProps } from './types';

export const AiSparkle: React.FC<AiSparkleProps> = ({ testId = 'ai-sparkle' }) => {
    const { t } = useTranslation();
    const label = t(TranslationKey.Common.AiGenerated);
    const gradientId = useId();

    return (
        <Tooltip content={label} className="shrink-0">
            <svg
                role="img"
                aria-label={label}
                data-testid={testId}
                viewBox={SPARKLE_VIEW_BOX}
                fill={`url(#${gradientId})`}
                className="inline-block size-text"
            >
                <SparkleGradient id={gradientId} />
                <path d={SPARKLE_PATH} />
            </svg>
        </Tooltip>
    );
};
